import * as z from "zod/v4";

export const hearAboutUsOptions = z.enum(
	[
		"Web",
		"TV Commercial",
		"Radio",
		"Billboard",
		"Social Media",
		"BBB",
		"Word of Mouth",
		"Email",
		"Letter or Postcard",
		"Door Hanger"
	],
	{ error: "Please select how you heard about us" }
);

export type HearAboutUsOptions = z.infer<typeof hearAboutUsOptions>;

export const submitOfferFormSchema = z.object({
	name: z.string().min(3, "Please enter your name"),
	email: z.email("Valid email is required"),
	phone: z.string().regex(/^\(\d{3}\) \d{3}-\d{4}$/, "Phone must be in format (XXX) XXX-XXXX"),
	hearAboutUs: hearAboutUsOptions,
	address: z.string().min(1, "Please enter your home address"),
	homeDetails: z.string().min(1, "Tell us about your home (optional)"),
	turnstileToken: z.string(),
	pageUrl: z.url(),
	routeId: z.string(),
	utmSource: z.string(),
	utmMedium: z.string(),
	utmCampaign: z.string(),
	utmContent: z.string(),
	utmTerm: z.string()
});

export type SubmitOfferFormSchema = z.infer<typeof submitOfferFormSchema>;

export const submitOfferFormClientSchema = submitOfferFormSchema.pick({
	name: true,
	email: true,
	phone: true,
	hearAboutUs: true,
	address: true,
	homeDetails: true,
	turnstileToken: true
});
